// extracted by mini-css-extract-plugin
export default {"container":"ApplicantDashboard_container__GrS3d","content":"ApplicantDashboard_content__u-wzO"};